import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../img/ic4-logo.svg";
import { ReactComponent as ShowPasswordIcon } from "../img/icons/icon_white_eye_slash.svg";
import { ReactComponent as HidePasswordIcon } from "../img/icons/icon_white_eye.svg";
import { useHistory, useLocation } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/hi";
import "moment/locale/mr";
import { getIC4ID, parsePID } from "../utils";

//TODO: To refactor
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useClinicState = createPersistedState("clinic");
const useProfileState = createPersistedState("profile");
//localStorage.clear();

/*
 * Funky destructing coming your way! :)
 * Following links helped me understand it
 * ES6 destructing 101 - https://simonsmith.io/destructuring-objects-as-function-parameters-in-es6
 * ES6 destructing nested objects - https://itnext.io/using-es6-to-destructure-nested-objects-in-javascript-avoid-undefined-errors-that-break-your-code-612ae67913e9
 */
function LoginPage({
  credentials: { patientId = "", password = "" } = {},
  errorMsg = "",
} = {}) {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const [credentials, setCredentials] = useState({
    patientId: patientId,
    password: password,
  });
  const [_, setToken] = useTokenState();
  const [__, setPID] = usePIDState();
  const [___, setClinic] = useClinicState();
  const [____, setProfile] = useProfileState();

  const [isFetching, setIsFetching] = useState(false);
  const { t, i18n } = useTranslation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCredentials((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  //const URL = `${API_BASE}/users/login`;
  const URL = `/api/v1/users/login`;
  const getProfile = (pid) => `/api/v1/users/profile/${pid}`;

  const onSubmit = async (data) => {
    setIsFetching(true);

    try {
      const response = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          patientId: getIC4ID(credentials.patientId),
          password: credentials.password,
        }),
      });

      const responseData = await response.json();

      if (!responseData?.status?.success) {
        throw new Error(responseData?.status?.message || "Login failed");
      }

      setToken(responseData["token"]);
      setPID(getIC4ID(credentials.patientId));

      if (credentials.patientId) {
        const profileResponse = await fetchProfile(
          getIC4ID(credentials.patientId),
          responseData["token"]
        );

        const queryParamClinicId = queryParams.get("cid");

        if (
          queryParamClinicId &&
          profileResponse?.profile?.clinicId !== queryParamClinicId
        ) {
          history.push(`/switch-doctor?cid=${queryParamClinicId}`);
          return; // Prevents navigation to `/intro`
        }
      }

      history.push("/intro");
    } catch (err) {
      setError(err.message || "Something went wrong");
      console.error("onSubmit error:", err);
    } finally {
      setIsFetching(false);
    }
  };

  const fetchProfile = async (pid, token) => {
    return await fetch(getProfile(pid), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          const locale = responseData["profile"]["language"];
          const clinicId = responseData["profile"]["clinicId"];
          setClinic(clinicId);
          setProfile(responseData["profile"]);
          console.log("Changing locale");
          moment.locale(locale);
          i18n.changeLanguage(locale);
        }
        return responseData;
      })
      .catch((err) => console.log(err));
  };

  const [error, setError] = useState(errorMsg);

  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const toggleIsPasswordShowValue = () => {
    setIsPasswordShow(!isPasswordShow);
  };

  const onRegister = () => {
    const clinicIdFromQueryParams = queryParams.get("cid");

    localStorage.removeItem("token");
    localStorage.removeItem("pid");
    localStorage.removeItem("Date");
    localStorage.removeItem("i18nextLng");
    localStorage.removeItem("onboardingHist");
    if (clinicIdFromQueryParams) {
      history.push({
        pathname: `/register`,
        search: `?cid=${clinicIdFromQueryParams.toString()}`,
      });
      // history.push(`/register?cid=${clinicIdFromQueryParams}`);
    } else {
      history.push(`/register`);
    }
  };

  return (
    <>
      <div className="login_block bg_darkblue">
        <div className="logo_block">
          <Logo className="img-fluid" />
        </div>
        <div className="fill_form dark_fill_form">
          <span className="txt_msg">{error}</span>
          <div className="field_group field_lbl_active">
            <label className="field_lbl">
              {t("login.REGISTRATION.inputLbl1")}
            </label>
            <input
              type="text"
              className="field_input"
              placeholder=""
              id="patientId"
              onChange={handleChange}
              value={credentials.patientId}
            />
          </div>
          {/*
            <Link
                to="#"
                className="link_fp d-flex justify-content-end"
            >
              {t('login.REGISTRATION.forgot-id')}
            </Link>
          */}
          <div className="field_group field_lbl_active">
            <label className="field_lbl">
              {t("login.REGISTRATION.inputLbl2")}
            </label>
            <input
              type={isPasswordShow ? "text" : "password"}
              id="password"
              className="field_input field_pwd"
              placeholder=""
              onChange={handleChange}
              value={credentials.password}
              autoComplete="off"
            />
            {credentials.password && (
              <span
                className="icon btn_pwd"
                id="btn_pwd"
                onClick={toggleIsPasswordShowValue}
              >
                {isPasswordShow ? (
                  <HidePasswordIcon className="img_eye img-fluid" />
                ) : (
                  <ShowPasswordIcon className="img_eye img-fluid" />
                )}
              </span>
            )}
          </div>
          <Link
            to="/forgot-password"
            className="link_fp d-flex justify-content-end"
          >
            {t("login.REGISTRATION.forgot-pwd")}
          </Link>
          <div className="btn_block d-flex justify-content-center">
            <button
              disabled={
                credentials.patientId === "" ||
                credentials.password === "" ||
                isFetching
              }
              className="btn btn_primary"
              onClick={() => onSubmit()}
            >
              {isFetching && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              {t("login.REGISTRATION.button1")}
            </button>
          </div>
          <div className="desc_block align-items-center">
            <span className="txt">{t("login.REGISTRATION.message")}</span>
            <a className="link_pr" onClick={onRegister}>
              {t("login.REGISTRATION.button2")}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
